import { PUBLIC_SITE_URL } from "@/config/env";

import type { DeckCardKakaoKind } from "./deckCardKakaoKind";

export type BuildDeckCardShareUrlInput = {
  kind: DeckCardKakaoKind;
  mainCardId: number | string;
  senderUserId: number;
  demoCardId?: number | string;
  origin?: string;
};

const normalizeOrigin = (origin: string): string => origin.replace(/\/+$/, "");

const deckCardFilter = (kind: DeckCardKakaoKind): string => {
  switch (kind) {
    case "single":
      return "Single_Card";
    case "demo":
      return "Demo_Card";
    case "season":
      return "Season_Card";
    case "impact":
      return "Impact_Card";
    default:
      return "Single_Card";
  }
};

const deckCardShareSearch = (
  kind: DeckCardKakaoKind,
  mainCardId: number | string,
  senderUserId: number,
  demoCardId?: number | string
): string => {
  const params = new URLSearchParams({
    filter: deckCardFilter(kind),
    id: String(mainCardId),
    userId: String(senderUserId),
  });

  if (kind === "demo" && demoCardId != null && String(demoCardId).trim()) {
    params.set("demoCardId", String(demoCardId));
  }

  return params.toString();
};

/** Public fan deck-card link for Kakao / copy share. */
export const buildDeckCardShareUrl = ({
  kind,
  mainCardId,
  senderUserId,
  demoCardId,
  origin =
    PUBLIC_SITE_URL ||
    (typeof window !== "undefined" ? window.location.origin : ""),
}: BuildDeckCardShareUrlInput): string => {
  const base = normalizeOrigin(origin);
  const search = deckCardShareSearch(kind, mainCardId, senderUserId, demoCardId);
  // return new URL(`/app-deck?${search}`, `${base}/`).href;
  return `${base}/lobby?${search}`;
};

export const buildDeckCardSharePath = (input: BuildDeckCardShareUrlInput): string => {
  const shareUrl = buildDeckCardShareUrl(input);
  const parsed = new URL(shareUrl);
  return `${parsed.pathname}${parsed.search}`.replace(/^\/+/, "");
};
